module.exports = __webpack_public_path__ + "img/Dantam Makeover 16.797a2b6c.jpg";